export const AUTH_CARD_PRINTING_START = "AUTH_CARD_PRINTING_START";
export const AUTH_CARD_PRINTING_SUCCESS = "AUTH_CARD_PRINTING_SUCCESS";
export const AUTH_CARD_PRINTING_FAILURE = "AUTH_CARD_PRINTING_FAILURE";
